import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelper } from 'angular2-jwt';
import { LogService } from '../../shared/log/log.service';
import {
  AuthenticationStore,
  ExternalSourceError
} from '../../permission/services/authentication.store';
import { UserPermission } from '../../permission/models/user-permission.model';

@Component({
  selector: 'pioneer-secured-home',
  templateUrl: './secured-home.component.html'
})
export class SecuredHomeComponent implements OnInit {

  token: string;
  jwtHelper: JwtHelper;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private authenticationStore: AuthenticationStore,
              private logService: LogService) {
    this.jwtHelper = new JwtHelper();
  }

  ngOnInit() {
    this.route.queryParams.map(params => params[ 'authorization' ]).filter(token => token)
      .delay(100) // We get errors without this delay
      .subscribe(token => this.storeTokenFromQueryString(token));
  }

  storeTokenFromQueryString(token: string): void {
    // this is necessary in case they were already logged in before coming to this page
    this.authenticationStore.logout();

    this.authenticationStore.handleTokenFromExternalSource(token).subscribe(
      (userPermission: UserPermission) => {
        this.logService.debug('subscribe handleTokenFromExternalSource');
        this.router.navigate([ '/' ]);
        this.logService.debug(`after navigate['/']`);
      },
      (error: ExternalSourceError) => {
        if (error === ExternalSourceError.TOKEN_EXPIRED) {
          this.router.navigate([ '/external-login-expired' ]);
          this.logService.debug(`after navigate['/external-login-expired']`);
        } else {
          this.router.navigate([ '/error', { error: 'MESSAGES.ERROR.EXTERNAL_LOGIN_ERROR' } ]);
        }
      }
    )
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/auth/secured-home/secured-home.component.ts